import { Box, Button, Typography } from "@mui/material";
import moment from "moment";
import {
	CheckCircleOutlineRounded,
	DangerousRounded,
	DescriptionRounded,
	DocumentScanner,
	EditNote,
	Publish,
} from "@mui/icons-material";
import { blue, grey, lightGreen, red, yellow } from "@mui/material/colors";

export const constraintsOptions = {
	UNIQUE: { name: "Unique", key: "UNIQUE", editable: false },
	NOTNULL: { name: "REQUIRED", key: "NOTNULL", editable: true },
	INPUT: { name: "INPUT", key: "INPUT", editable: true },
	DISPLAY: { name: "Display", key: "DISPLAY", editable: true },
	UPPERCASE: { name: "Uppercase", key: "UPPERCASE", editable: true },
};
export const objType = "obj";
export const arrType = "arr";
export const isNewKey = "is_new";
export const allOption = "ALL";

export const relAttrGrpAttrAssocObj = "groupAttributes";
export const relAttrValAssocObj = "attributeValues";

export const inputTypes = {
	SELECT: { name: "Select", key: "SELECT" },
	MULTIPLE_SELECT: { name: "Multiple Select", key: "MULTIPLE_SELECT" },
	ENTER: { name: "Enter", key: "ENTER" },
	AUTO_GENERATE: { name: "Autogenerate", key: "AUTO_GENERATE" },
};
export const datatypes = {
	STRING: { name: "String", key: "STRING", htmlVar: "string", sqlVar: "varchar(255)" },
	LONGTEXT: { name: "Long Text", key: "LONGTEXT", htmlVar: "string", sqlVar: "LONGTEXT" },
	FILE: { name: "FILE", key: "FILE", htmlVar: "file", sqlVar: "varchar(255)" },
	NUMBER: { name: "Number", key: "NUMBER", htmlVar: "number", sqlVar: "integer" },
	DECIMAL: { name: "Decimal", key: "DECIMAL", htmlVar: "number", sqlVar: "float" },
	DATE: { name: "Date", key: "DATE", htmlVar: "date", sqlVar: "DATETIME" },
	JSON: { name: "Json", key: "JSON", htmlVar: "file", sqlVar: "JSON" },
	BOOLEAN: { name: "Booelan", key: "BOOLEAN", htmlVar: "radio", sqlVar: "TINYINT" },
	DATE_TIMESTAMP: { name: "Date Timestamp", key: "DATE_TIMESTAMP", htmlVar: "date", sqlVar: "DATETIME" },
};
export const selectOptKeyName = "select_options";

export const colStyle = {
	headerAlign: "center",
	align: "center",
	flex: 1,
	minWidth: 120,
};

const tableMetadataDatagridRenderCells = {
	url: {
		field: "url",
		headerName: "URL",
		minWidth: 120,
		...colStyle,
		flex: 1,
		renderCell: ({ row, field }) => {
			return <Typography component={row?.file ? "data" : ""}>{row.url}</Typography>;
		},
	},
};
export const getColDefaultValue = (col) => {
	if (col?.input_type === inputTypes.ENTER.key) {
		return col?.data_type === datatypes.STRING.key
			? ""
			: col?.data_type === datatypes.NUMBER.key
			? 0
			: col?.data_type === datatypes.DECIMAL.key
			? 0.0
			: "";
	} else if (col?.input_type === inputTypes.SELECT.key) {
		return inputTypes.SELECT.key;
	} else if (col?.input_type === inputTypes.MULTIPLE_SELECT.key) return [];
	return "";
};

export const isColumnDefault = (col, value) => {
	if (Array.isArray(value)) return value?.length ? false : true;
	if (value === getColDefaultValue(col) || !value) return true;
	else return false;
};
export const getColumnValue = (col, data) => {
	if (col?.data_type === datatypes.DATE.key) {
		return moment(data?.[col.key]).format("DD-MM-YYYY") || "--";
	} else if (col.input_type == inputTypes.MULTIPLE_SELECT.key) {
		return data?.[col.key]?.join(",") || "--";
	} else {
		return data?.[col.key] || "--";
	}
};
export const converAttrToDatagridCol = (attr) => {
	if (tableMetadataDatagridRenderCells?.[attr.key]) return tableMetadataDatagridRenderCells[attr.key];
	else {
		let obj = {
			field: attr?.key,
			headerName: attr?.name,
			minWidth: 120,
			...colStyle,
			flex: 1,
			editable: attr?.editable,
			valueGetter: (value, row) => {
				if (attr?.input_type === inputTypes.SELECT.key) {
					// return attr?.[selectOptionsKeyName]?.list?.find((option) => option.key === value)
					// 	?.name;
					return value;
				} else if (attr?.input_type === inputTypes.MULTIPLE_SELECT.key) {
					return Array.isArray(value)
						? value
								.map((val) => {
									// return 	attr?.[selectOptionsKeyName]?.list?.find(
									// 		(option) => option.key === val
									// 	)?.name
									return val;
								})
								.join(", ")
						: [];
				} else if (attr?.data_type === datatypes.DATE.key) {
					return value ? moment(value).format("DD/MM/YYYY") : "";
				} else {
					return value;
				}
			},
		};
		if (attr?.headerClassName) obj["headerClassName"] = attr?.headerClassName;

		if (typeof attr.renderHeader === "function") {
			obj["renderHeader"] = ({ colDef }) => {
				return attr.renderHeader({ col: { ...colDef, ...attr } });
			};
		}

		return obj;
	}
};

export const parseAttrInput = (value, attr) => {
	if (attr?.input_type === inputTypes.SELECT.key) {
		// return attr?.[selectOptionsKeyName]?.list?.find((option) => option.key === value)
		// 	?.name;
		return value;
	} else if (attr?.input_type === inputTypes.MULTIPLE_SELECT.key) {
		return Array.isArray(value)
			? value
					.map((val) => {
						// return 	attr?.[selectOptionsKeyName]?.list?.find(
						// 		(option) => option.key === val
						// 	)?.name
						return val;
					})
					.join(", ")
			: [];
	} else if (attr?.data_type === datatypes.DATE.key) {
		return value ? moment(value).format("DD/MM/YYYY") : "";
	} else {
		return value;
	}
};
export const statusOptions = {
	CREATED: { name: "Created", color: blue[300], key: "CREATED", icon: <EditNote /> },
	NEW: { name: "New", color: blue[300], key: "NEW", icon: <DocumentScanner /> },
	DRAFTED: { name: "Drafted", color: grey[300], key: "DRAFTED", icon: <DescriptionRounded /> },
	APPROVED: { name: "Approved", color: lightGreen["A700"], key: "APPROVED", icon: <CheckCircleOutlineRounded /> },
	PUBLISHED: { name: "Published", color: lightGreen["A700"], key: "PUBLISHED", icon: <CheckCircleOutlineRounded /> },

	REJECTED: { name: "Rejected", color: red[600], key: "REJECTED", icon: <DangerousRounded /> },
};

export const createdByColumns = [
	{
		name: "Created By",
		key: "created_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Last Updated By",
		key: "last_updated_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
];
export const primaryKeyColumn = {
	name: "Id",
	key: "id",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
	meta_data: true,
};
export const approvalColumns = [
	{
		name: "Approval",
		key: "is_approved",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.BOOLEAN.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Approved By",
		key: "approved_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Approved Date",
		key: "approved_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 0,
		meta_data: true,
	},
];

export const publishColumns = {
	status: {
		name: "Status",
		key: "status",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	published_by: {
		name: "Published By",
		key: "published_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	published_date: {
		name: "Published Date",
		key: "published_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 0,
		meta_data: true,
	},
};

export const publishTableColumn = (publishFun = () => {}, disableBtn = false) => {
	return {
		headerName: publishColumns.status.name,
		field: publishColumns.status.key,
		minWidth: 130,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			if (row?.[publishColumns.status.key] === (statusOptions.PUBLISHED.key || statusOptions.REJECTED.key))
				return (
					<Box display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							// columnGap={1}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}{" "}
							<Typography pl="3px"> {statusOptions[row.status]?.name ?? "----"}</Typography>
						</Box>
					</Box>
				);
			else if (disableBtn)
				return (
					<Box display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							// columnGap={1}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}{" "}
							<Typography pl="3px"> {statusOptions[row.status]?.name ?? "----"}</Typography>
						</Box>
					</Box>
				);
			else
				return (
					<Button onClick={(e) => publishFun(e, row)} variant="contained" size="small" startIcon={<Publish />}>
						Publish
					</Button>
				);
		},
	};
};
export const muiCustomScrollbar = {
	"&::-webkit-scrollbar": {
		width: "0.45em",
	},
	"&::-webkit-scrollbar-track": {
		boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.08)",
		webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: grey[700],
		borderRadius: "4px",
		// outline: "1px solid slategrey",
	},
	"&::-webkit-scrollbar-thumb:hover": {
		backgroundColor: grey[800],
		// outline: "1px solid slategrey",
	},
};
